//=================================================
//    summary: DCP 老師看 學生提交的練習卷 列表 頁面 -- Hook
//
//    remarks: 000 Tim 2021/11/12 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2020/12/27 搬移到 Tool 改成 Popup Windows
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentPracticeSheet from './AssignmentPracticeSheet.module.scss'

import AssignmentAnswerWindow from '../AssignmentAnswerWindow/AssignmentAnswerWindow'
import {GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let marrScoreList = []
let mstrTitle = ""
let mobjShowComponentParam = null
let mobjAuthorizedSubscription = null
let mobjNoAuthorizedParam = null
let mblnDirty = false
// #endregion Member Variables

// #region Enumeration
const ReportStatusEnum = {
    "NA": 0,
    "ScoreIt": 1,
    "Result": 2
}
// #endregion Enumeration


const COMP_NAME = "AssignmentPracticeSheet"

function AssignmentPracticeSheet(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [isShowAssignmentAnswerWindow, setIsShowAssignmentAnswerWindow] = useState(false)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        mstrTitle = window.gAppUI.LBL_PracticeSheet

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false
            marrScoreList = []
            mstrTitle = ""
            mblnDirty = false

            setUpdateDataTime(0)
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉 按鈕
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME +  ".CloseOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "CloseShowAssignmentPracticeSheet",
            "Dirty": mblnDirty
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 狀態按鈕
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function StatusButtonOnTapHandler(ScoreData, ScoreIndex)
    {
        console.log(COMP_NAME + ".StatusButtonOnTapHandler: ", ScoreData)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let intAssignReportStatus = 0
        if (
            (typeof(ScoreData.Score) === 'undefined') ||
            (ScoreData.Score === null)
            )
        {
            intAssignReportStatus = window.gAssignReportStatusEnum.TeacherScore
        }
        else
        {
            intAssignReportStatus = window.gAssignReportStatusEnum.TeacherResult
        }

        let strLessonID = props.Arguments.LessonID.toString().PadLeft(5)          // 左邊補零 Format "01001"

        // 這邊如果沒有授權 也要跑一下 NoAuthorizedProcess
        let intBookSeqNo = window.Globals.GetBookSeqNoFromLessonID(strLessonID)
        let strBookSeqNo = intBookSeqNo.toString().PadLeft(2)

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(strLessonID))
        {
            blnExpired = false
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        } 

        let objAssignmentData = {
            "AssignID": ScoreData.AssignID,
            "LessonID": strLessonID,
            "StudentID": ScoreData.StudentAccID,
            "LUCatSeqNo": props.Arguments.LUCatSeqNo,
            "AssignedClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
            "AssignReportStatus": intAssignReportStatus,
            "ScoreIndex": ScoreIndex
        }

        if (!blnExpired)
        {
            // 有授權
            // 前往 老師改考卷 or 老師看考卷
            mobjShowComponentParam = {
                "AssignmentData": objAssignmentData
            }

            console.log(COMP_NAME + ".StatusButtonOnTapHandler mobjShowComponentParam: ", mobjShowComponentParam)

            setIsShowAssignmentAnswerWindow(true)
        }
        else
        {
            // 沒授權
            // 註冊 重新取得授權後流程
            RegisterReGetAuthorizedAfterProcess()
            
            mobjNoAuthorizedParam = {
                "AssignmentData": objAssignmentData,
                "BookSeqNo": strBookSeqNo,
                "LessonID": strLessonID
            }
            NoAuthorizedProcess(window.gSession.App.BookCatID, strBookSeqNo, strLessonID, props.Arguments.LUCatSeqNo)
        }
    } // end of StatusButtonOnTapHandler
    // #endregion OnTapHandler
    
    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2021/12/27 改呼叫 上一層 去執行
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2021/12/27 改呼叫 上一層 去執行
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2021/12/27 改呼叫 上一層 去執行
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowAssignmentAnswerWindow")
        {
            mobjShowComponentParam = null
            setIsShowAssignmentAnswerWindow(false)
        }
        else if (CallbackObj.Action === "SubmitSuccessAssignmentAnswerWindow")
        {
            ResetScoreData4SubmitSuccess(parseInt(CallbackObj.AssignID), parseInt(CallbackObj.Score))

            mblnDirty = true
            mobjShowComponentParam = null
            setIsShowAssignmentAnswerWindow(false)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region AlertCallBack
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2020/12/27 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            let objCallbackData = {
                "Action": "NoAuthorizedGoToSubscription",
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // 取消的話，清空資料
        }
        mobjAuthorizedSubscription = null
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack
    // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        // 到後端 取得 資料
        mobjCallParam = {
            "ClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
            "BookCategoryID": window.gSession.App.BookCatID,
            "LessonID": props.Arguments.LessonID,
            "LUCatSeqNo": props.Arguments.LUCatSeqNo,
            "Assignee": props.Arguments.Assignee,
            "DataType": 2 
        }
        GetAssigneeNewAssignList()
    } // end of PaintedMe

    /*===========================================
    summary: 註冊 重新取得 授權後流程
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function RegisterReGetAuthorizedAfterProcess ()
    {
        let objCallbackData = {
            "Action": "RegisterReGetAuthorizedAfterProcess",
            "Function": ReGetAuthorizedAfterProcess
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterReGetAuthorizedAfterProcess

    /*===========================================
    summary: 重新取得 授權後流程
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function ReGetAuthorizedAfterProcess ()
    {
        // mobjNoAuthorizedParam = {
        //     "AssignmentData": objAssignmentData,
        //     "BookSeqNo": strBookSeqNo,
        //     "LessonID": strLessonID
        // }
        
        let strBookSeqNo = mobjNoAuthorizedParam.BookSeqNo
        let strLessonID = mobjNoAuthorizedParam.LessonID

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(strLessonID))
        {
            blnExpired = false;
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        }

        if (!blnExpired)
        {
            // 有授權
            // 前往 老師改考卷 or 老師看考卷
            mobjShowComponentParam = {
                "AssignmentData": mobjNoAuthorizedParam.AssignmentData
            }

            console.log(COMP_NAME + ".ReGetAuthorizedAfterProcess mobjShowComponentParam: ", mobjShowComponentParam)

            setIsShowAssignmentAnswerWindow(true)
        }
        else
        {
            // 沒授權
            console.log(COMP_NAME + ".ReGetAuthorizedAfterProcess NoAuthorized")
        }

        mobjNoAuthorizedParam = null
    } // end of ReGetAuthorizedAfterProcess

    /*===========================================
    summary: 初始化標題文字
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetTitleText()
    {
        console.log(COMP_NAME + ".GetTitleText")
        
        let strTitle = window.gAppUI.LBL_PracticeSheet

        let objScoreData = marrScoreList[0]

        let intIndex = 0
        let intCount = window.garrPracticeLU.length
        let blnFound = false
        
        let strSectionName = ""
        let intLessonID = parseInt(props.Arguments.LessonID) % 100
        let strUserName = ""

        if (
            (typeof(objScoreData) !== 'undefined') &&
            (objScoreData !== null)
            )
        {
            strUserName = window.Globals.FormateDisplayName(objScoreData.FirstName, objScoreData.LastName, objScoreData.LoginName)
            
            while ((!blnFound) && (intIndex < intCount))
            {
                if (window.garrPracticeLU[intIndex].LUCatSeqNo === parseInt(objScoreData.LUCatSeqNo))
                {
                    strSectionName = window.garrPracticeLU[intIndex].DisplayName
                    blnFound = true
                }
                intIndex++
            } // end of while

            strTitle = window.gAppUI.LBL_Lesson + ' ' + intLessonID
            strTitle += ' - ' + strSectionName
            strTitle += ' ' + window.gAppUI.LBL_History
            strTitle += ' - ' + strUserName
        } // end of if (objScoreData !== null)

        return strTitle
    } // end of GetTitleText

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function NoAuthorizedProcess (BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": window.gAuthorizedSubscriptionTypeEnum.AssignReport
        }

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess

    /*===========================================
    summary: 重新設定 ScoreData 顯示資料 
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function ResetScoreData4SubmitSuccess (AssignID, Score)
    {
        let objScoreData = marrScoreList.find(ScoreData => parseInt(ScoreData.AssignID) === AssignID)
        objScoreData.Score = Score.toString()
        objScoreData.Status = ReportStatusEnum.Result

        console.log("ResetScoreData4SubmitSuccess End marrScoreData4List: ", marrScoreList)
    } // end of ResetScoreData4SubmitSuccess
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 分數顯示 Cls
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetScoreValueCls (Score)
    {            
        let objCls = cssAssignmentPracticeSheet.divScoreValueCell
        
        if (
            (typeof(Score) === 'undefined') ||
            (Score === null)
            )
        {
            objCls = cssAssignmentPracticeSheet.divScoreValueCellNA
        }

        return objCls
    }  // end of GetScoreValueCls

    /*===========================================
    summary: 取得 狀態按鈕 Cls
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetStatusButtonCls (Status)
    {            
        var objCls = cssAssignmentPracticeSheet.divStatusButton
        
        switch (Status)
        {
            case ReportStatusEnum.ScoreIt:
                objCls = cssAssignmentPracticeSheet.divStatusButtonScoreIt
                break
            case ReportStatusEnum.Result:
            default:
                objCls = cssAssignmentPracticeSheet.divStatusButtonResult
                break
        }

        return objCls
    }  // end of GetStatusButtonCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 取得 學生 提交的練習卷 完畢
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetAssigneeNewAssignListAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAssigneeNewAssignListAfterProcess")

        marrScoreList = ReturnData.ScoreList

        console.log(COMP_NAME + ".GetAssigneeNewAssignListAfterProcess marrScoreList: ", marrScoreList)
        mobjCallParam = null

        mstrTitle = GetTitleText()
        
        setUpdateDataTime(new Date().getTime())
    } // end of GetAssigneeNewAssignListAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得 學生 提交的練習卷
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetAssigneeNewAssignList()
    {        
        let objRetryFuncRef = GetAssigneeNewAssignList
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAssigneeNewAssignListCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssigneeNewAssignList)

            let objCallData = {
                "Func": "GetAssigneeNewAssignList",
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "Assignee": mobjCallParam.Assignee,
                "DataType": mobjCallParam.DataType
            }
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAssigneeNewAssignList

    /*===========================================
    summary: 取得 學生 提交的練習卷 Callback
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetAssigneeNewAssignListCallback(Return)
    {        
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAssigneeNewAssignList_No
        let strErrorTitle = window.gAppUI.ERR_GetAssigneeNewAssignList_Title
        let strErrMsg = window.gAppUI.ERR_GetAssigneeNewAssignList_Msg
        // end of customize
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAssigneeNewAssignListCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAssigneeNewAssignListCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAssigneeNewAssignListCallback Return.Data: ", Return.Data)

            GetAssigneeNewAssignListAfterProcess(Return.Data)
        }
    } // end of GetAssigneeNewAssignListCallback
    // #endsregion Web Service

    // #region Render元件
    /*===========================================
    summary: 分數列表 分數 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreStatusValueCell( {ScoreData, ScoreIndex} )
    {        
        let strButton = ""
        let intStatus = 0

        if (ScoreData.Score === null)
        {
            intStatus = ReportStatusEnum.ScoreIt
            strButton = window.gAppUI.BTN_Score
        }
        else
        {
            intStatus = ReportStatusEnum.Result
            strButton = window.gAppUI.BTN_Result
        }

        return (
            <div className={cssAssignmentPracticeSheet.divStatusValueCell}>
                <div className={GetStatusButtonCls(intStatus)} onClick={() => StatusButtonOnTapHandler(ScoreData, ScoreIndex)}>
                    {strButton}
                </div>
            </div>
        )
    } // end of ComponentScoreStatusValueCell

    /*===========================================
    summary: 分數列表 分數 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreScoreValueCell( {Score} )
    {        
        let strScore = ""

        if (
            (typeof(Score) === 'undefined') ||
            (Score === null)
            )
        {
            strScore = window.gAppUI.LBL_NotScore
        }
        else
        {
            strScore = Score
        }

        return (
            <div className={GetScoreValueCls(Score)}>
                {strScore}
            </div>
        )
    } // end of ComponentScoreScoreValueCell                

    /*===========================================
    summary: 分數列表 標題 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreDateValueCell( {TestedTime} )
    {        
        let strDate = ""
        if (
            (typeof(TestedTime) !== 'undefined') &&
            (TestedTime !== null)
            )
        {
            let datTestedLocal = TestedTime.ToUTC()
            strDate = datTestedLocal.ToBCLocalTimeString()
        }

        return (
            <div className={cssAssignmentPracticeSheet.divDateValueCell}>
                {strDate}
            </div>
        )
    } // end of ComponentScoreDateValueCell

    /*===========================================
    summary: 分數列表 標題 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreTitleRow()
    {        
        return (
            <div className={cssAssignmentPracticeSheet.divScoreTitleRow}>
                <div className={cssAssignmentPracticeSheet.divDateTitleCell}>
                    {window.gAppUI.LBL_Date}
                </div>
                <div className={cssAssignmentPracticeSheet.divScoreTitleCell}>
                    {window.gAppUI.LBL_Score}
                </div>
                <div className={cssAssignmentPracticeSheet.divStatusTitleCell}>
                    {window.gAppUI.LBL_Status}
                </div>
            </div>
        )
    } // end of ComponentScoreTitleRow

    /*===========================================
    summary: Title 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentTitle() 
    {   
        return(
            <div className={cssAssignmentPracticeSheet.divTitle}>
                {mstrTitle}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: 離開按鈕 顯示Component
    remarks: 000 Tim 2021/11/11 Create
             001 Tim 2022/01/17 將 Close 感應區改大
    ===========================================*/
    function ComponentCloseButton() 
    {   
        return(
            <div className={cssAssignmentPracticeSheet.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                <div className={cssAssignmentPracticeSheet.btnCloseIcon}/>
            </div>
        )
    } // end of ComponentCloseButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render AssignmentAnswerWindow 的顯示
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function RenderAssignmentAnswerWindowWrapper(StateIsShowAssignmentAnswerWindow)
    {
        if (StateIsShowAssignmentAnswerWindow)
        {
            return(
                <AssignmentAnswerWindow AssignmentData={mobjShowComponentParam.AssignmentData}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAssignmentAnswerWindowWrapper

    /*===========================================
    summary: Render 分數列表 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderScoreListWrapper(ScoreData, ScoreIndex)
    {
        return (
            <>
                <ComponentScoreDateValueCell TestedTime={ScoreData.TestedTime}/>
                <ComponentScoreScoreValueCell Score={ScoreData.Score}/>
                <ComponentScoreStatusValueCell ScoreData={ScoreData} ScoreIndex={ScoreIndex}/>
            </>
        )
    } // end of RenderScoreListWrapper

    /*===========================================
    summary: Render TopTool 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssAssignmentPracticeSheet.divTopTool}>
                <ComponentTitle/>
                <ComponentCloseButton />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentPracticeSheet.divContent}>
                    <ComponentScoreTitleRow />

                    {marrScoreList.map((ScoreData, ScoreIndex) =>
                        <div key={ScoreIndex} className={cssAssignmentPracticeSheet.divValueRow}>
                            {RenderScoreListWrapper(ScoreData, ScoreIndex)}
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                <div className={cssAssignmentPracticeSheet.divBG}>
                    {RenderTopToolWrapper()}
                    {RenderContentWrapper(updateDataTime)}
                </div>

                {RenderAssignmentAnswerWindowWrapper(isShowAssignmentAnswerWindow)}
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentPracticeSheet